import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import PropertyPage from "@/pages/PropertyPage";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import WriteReview from "@/pages/WriteReview";
import TenantDashboard from "@/pages/TenantDashboard";
import LandlordDashboard from "@/pages/LandlordDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import ContentPage from "@/pages/ContentPage";
import Contact from "@/pages/Contact";
import VerifyEmail from "@/pages/VerifyEmail";
import ConfirmReview from "@/pages/ConfirmReview";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import SearchResults from "@/pages/SearchResults";
import ScrollToTop from "@/components/ScrollToTop";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/search" element={<SearchResults />} />
            <Route path="/address/:slug" element={<PropertyPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/write-review" element={<WriteReview />} />
            <Route path="/tenant" element={<TenantDashboard />} />
            <Route path="/landlord" element={<LandlordDashboard />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/how-it-works" element={<ContentPage file="how-it-works.html" title="How Tenverly Works" heading="How Tenverly Works" subtitle="Honest rental reviews, backed by proof of tenancy and checked by real people." />} />
            <Route path="/review-guidelines" element={<ContentPage file="review-guidelines.html" title="Review Guidelines" heading="Review Guidelines" subtitle="What we expect from every review on Tenverly." />} />
            <Route path="/renting-tips" element={<ContentPage file="renting-tips.html" title="Renting Tips" heading="Renting Tips" subtitle="Practical advice before you sign and move in." />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<ContentPage file="privacy.html" title="Privacy Policy" heading="Privacy Policy" />} />
            <Route path="/terms" element={<ContentPage file="terms.html" title="Terms & Conditions" heading="Terms & Conditions" />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/confirm-review/:token" element={<ConfirmReview />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;
